<script>
import MenuItem from '@wielink-application/shared/vue/layouts/partials/sidebar/menu-item.vue'
export default MenuItem;
</script>